export const WF_Z_INDEX = {
  // dropdowns in header must be above sidebar
  OVERLAY: 4,
  HEADER: 3,
  SIDEBAR: 2,
  WF_ANALYTICS: 2,
};
